import React from 'react';

import { useTheme } from 'styled-components';

import { FaCheck } from 'react-icons/fa';

import { Container } from './styles';

import { LabelProps } from './interface';

const Label: React.FC<LabelProps> = ({ number, label, subtitle, status }) => {
  const { colors } = useTheme();

  return (
    <Container status={status}>
      <span>
        <strong>{number}</strong>
        {status ? (
          <i>
            <FaCheck
              size={22}
              color={
                status ? colors.FORM_LABEL_IC_ENABLE : colors.FORM_LABEL_IC
              }
            />
          </i>
        ) : null}
      </span>

      <div>
        <small>{label}</small>
        <p>{subtitle}</p>
      </div>
    </Container>
  );
};

export default Label;
